<template>
  <TableCard
    :loading="loading"
    :groupable-by="[
            {value: 'Question', label: $t('Inspection items')},
            {value: 'Inspector', label: $t('Inspectors')},
            {value: 'EntityItem', label: $t('Entity items')},
            {value: 'Group', label: $t('Groups')},
            {value: 'Category', label: $t('Categories')},
            {value: 'Checklist', label: $t('Checklists')},
            {value: 'Section', label: $t('Pages / sections')},
        ]"
    :group-by="groupBy"
    :data="results"
    format="analyticsPercentage"
    @rowClick="handleRowClick"
    @export="handleExport"
    @groupByChanged="handleGroupByChanged"
  >
    <i18n path="with worst {item}" tag="p" :dummy="$t('with worst {item}')">
      <template v-slot:item>
        <span class="font-semibold underline cursor-pointer" @click="$emit('click')">
          {{ $t('average score') }}
        </span>
      </template>
    </i18n>
  </TableCard>
</template>

<script>
  import TableCard from '@/_legacy/views/Analytics/components/TableCard.vue';
  import { QuestionGroupBy } from '@/services/api/resources/analytics/types';

  export default {
    components: { TableCard },
    props: {
      loading: {
        type: Boolean,
        default: true,
      },
      groupBy: {
        type: String,
        default: QuestionGroupBy.Question,
      },
      results: {
        type: Array,
        default: () => [],
      },
    },
    methods: {
      handleGroupByChanged(value) {
        this.$emit('groupByChanged', value);
      },
      handleExport(format) {
        this.$emit('exportClicked', format);
      },
      handleRowClick(row) {
        this.$emit('rowClick', {
          row,
          groupBy: this.groupBy,
        });
      },
    },
  };
</script>
